import { OPPORTUNITIES_TABLE, pickAuditFields } from './opportunityAuditShared.js';

const context = {
  email: '',
  name: '',
  path: '',
  getToken: null,
};

const recentKeys = new Set();

export function setOpportunityAuditContext(next = {}) {
  if (next.email != null) context.email = next.email;
  if (next.name != null) context.name = next.name;
  if (next.path != null) context.path = next.path;
  if (next.getToken != null) context.getToken = next.getToken;
}

export function getOpportunityAuditContext() {
  return { ...context };
}

function dedupeKey(entry) {
  return `${entry.action}:${entry.recordId}:${JSON.stringify(pickAuditFields(entry.after || {}))}`;
}

export async function queueOpportunityAudit(entry) {
  if (typeof window === 'undefined') return;
  const key = dedupeKey(entry);
  if (recentKeys.has(key)) return;
  recentKeys.add(key);
  setTimeout(() => recentKeys.delete(key), 3000);

  try {
    const token = typeof context.getToken === 'function' ? await context.getToken() : null;
    await fetch('/api/admin/opportunity-audit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        action: entry.action,
        recordId: entry.recordId,
        before: pickAuditFields(entry.before || {}),
        after: pickAuditFields(entry.after || {}),
        source: entry.source || context.path || window.location?.pathname || '',
      }),
      keepalive: true,
    });
  } catch (error) {
    console.warn('[opportunity-audit] failed to record write', error);
  }
}

export function isOpportunityTableUrl(url) {
  const value = String(url || '');
  return (
    value.includes(encodeURIComponent(OPPORTUNITIES_TABLE)) ||
    value.includes(OPPORTUNITIES_TABLE) ||
    value.includes('ALLGRANTS')
  );
}
